module.exports = __webpack_public_path__ + "img/seo-monitoring.e363a64d.svg";